import React from "react";
import {
  Box,
  HStack,
  VStack,
  Skeleton,
  useColorModeValue,
} from "@chakra-ui/react";

export default function JournalSkeleton() {
  const shimmerStart = useColorModeValue("gray.100", "gray.700");
  const shimmerEnd = useColorModeValue("blue.50", "gray.600");
  const skeletonProps = { startColor: shimmerStart, endColor: shimmerEnd, speed: 1.2 };
  const cardBg = useColorModeValue("white", "gray.700");

  return (
    <>
      {/* Save/Cancel button row */}
      <HStack spacing={3} mb={2}>
        <Skeleton height="32px" width="75px" borderRadius="md" {...skeletonProps} />
        <Skeleton height="32px" width="75px" borderRadius="md" {...skeletonProps} />
      </HStack>

      {/* Paper box area */}
      <HStack justifyContent="center" alignItems="center" w="100%">
        {/* Back arrow placeholder */}
        <Skeleton height="32px" width="32px" borderRadius="full" {...skeletonProps} />

        {/* Paper card */}
        <Box
          bg={cardBg}
          boxShadow="md"
          p={5}
          mx="auto"
          w="80%"
          maxW="800px"
          minH="70vh"
          rounded="lg"
        >
          <VStack spacing={4} align="stretch">
            {/* Clear / Date / Edit row */}
            <HStack justify="space-between" pb={2}>
              <Skeleton height="32px" width="70px" borderRadius="md" {...skeletonProps} />
              <Skeleton height="32px" width="180px" borderRadius="md" {...skeletonProps} />
              <Skeleton height="32px" width="70px" borderRadius="md" {...skeletonProps} />
            </HStack>

            {/* Toolbar placeholder */}
            <Skeleton height="40px" width="100%" borderRadius="md" {...skeletonProps} />

            {/* Editor area */}
            <Skeleton height="55vh" width="100%" borderRadius="md" {...skeletonProps} />
          </VStack>
        </Box>

        {/* Next arrow placeholder */}
        <Skeleton height="32px" width="32px" borderRadius="full" {...skeletonProps} />
      </HStack>
    </>
  );
}
